import { ExpandMore } from "@mui/icons-material";
import {
  Box,
  Collapse,
  Container,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { theme } from "../../utilities/themes";
import { SplashContext } from "../layout/layout";

const FAQ = () => {
  const [question, setQuestion] = useState(-1);
  const spanFontSizes1 = {
    fontSize: { lg: "1.125rem", md: "1rem", sm: "0.875rem", xs: "0.875rem" },
  };
  const spanFontSizes2 = {
    fontSize: { lg: "1rem", md: "0.875rem", sm: "0.75rem", xs: "0.75rem" },
  };
  const Content = ({ children }) => {
    return <Box sx={{ ...spanFontSizes2, fontWeight: 300 }}>{children}</Box>;
  };
  const splashScreen = useContext(SplashContext);
  useEffect(() => {
    splashScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const Header1 = ({ children, index, clickable = true }) => {
    return (
      <Typography
        component={"span"}
        onClick={() =>
          clickable && question !== index ? setQuestion(index) : setQuestion(-1)
        }
        className={"faquestion ".concat(clickable ? "" : " noClick")}
        sx={{
          ...spanFontSizes1,
          color: question === index && theme.palette.primary.main,
          cursor: clickable && "pointer",
          display: "inline-block",
          width: "90%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {children}
          {clickable && (
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "row-reverse",
              }}
            >
              <ExpandMore
                fontWeight={100}
                sx={{
                  transition: "transform 0.3s",
                  transform:
                    question === index ? "rotate(180deg)" : "rotate(0)",
                  fontSize: 24,
                }}
              />
            </Box>
          )}
        </Box>
      </Typography>
    );
  };
  return (
    <Container maxWidth="xl">
      <Stack spacing={1} sx={{ pt: 3, minHeight: "90vh", pb: 3 }}>
        <ol className="ol">
          <li className="li">
            <Header1 index={0}>What is a Little Movie Experience?</Header1>
            <Collapse in={question === 0}>
              <Content>
                The little movie experience is a service within the Little super
                app that allows you to buy a ticket from a Cinema of your
                preference, buy snacks and order a ride to the Cinema giving you
                convenience and efficiency. Our current partners are as below:
                <ol>
                  <li>Century Cinemax Sarit,</li>
                  <li>Century Imax Garden City,</li>
                  <li>Century Cinemax Junction,</li>
                  <li>Anga Diamond Plaza,</li>
                  <li>Anga Sky Panari,</li>
                  <li>Motion Cinema Green Span Mall,</li>
                  <li>Prestige Cinema.</li>
                </ol>
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={1}>
              Why am I getting a pop-up message from M-pesa when loading my
              wallet via M-Pesa?
            </Header1>
            <Collapse in={question === 1}>
              <Content>
                STK Push is an Instant prompt to input an M-pesa pin. The delay
                is commonly experienced only if the client&rsquo;s number is
                ported. (Changed from Safaricom to Airtel or Telkom etc.). You
                can top up your Little Wallet (or Driver Account- if using
                Driver App) directly through Mpesa. &nbsp;
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={2}>
              How can I load my wallet directly from M-Pesa?
            </Header1>
            <Collapse in={question === 2}>
              <Content>
                <ol className="ol2">
                  <li className="li2">Log into your Little App</li>
                  <li className="li2">Click on Wallet</li>
                  <li className="li2">Click on Load Cash</li>
                  <li className="li2">Select Cash Source (Card or Mpesa)</li>
                  <li className="li2">
                    Select Which Wallet to load e.g. Common Wallet
                  </li>
                  <li className="li2">
                    Enter the amount then &ldquo;Load Wallet&rdquo;
                  </li>
                </ol>
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={3}>
              How can I link my VISA/MASTERCARD to my Little App?
            </Header1>
            <Collapse in={question === 3}>
              <Content>
                <ol className="ol2">
                  <li className="li2">Log into your Little App</li>
                  <li className="li2">
                    Click on &ldquo;Add Payments&rdquo; then &ldquo;Credit/Debit
                    Cards&rdquo;
                  </li>
                  <li className="li2">
                    Click on &ldquo;Proceed&rdquo; to add card details and
                    &ldquo;SUBMIT&rdquo; to add the card.
                  </li>
                </ol>
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={4}>
              Can I be refunded after buying a ticket?
            </Header1>
            <Collapse in={question === 4}>
              <Content>
                Once a ticket is purchased it cannot be refunded.
              </Content>
              <Content>
                NB: We cannot redeem a ticket for a particular movie with a
                different movie because the distributors are different.
              </Content>
              <Content>
                In the event you need to reach out to us don't hesitate to get
                in touch with us via email at{" "}
                <a
                  href="mailto:partnerships@little.africa"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  partnerships@little.africa
                </a>{" "}
                or via the{" "}
                <a
                  href="/contact-us"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  “contact us”
                </a>{" "}
                window in the app
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={5}>
              How do I know the position of my seat in the cinema and if I want
              to change it can I do so?
            </Header1>
            <Collapse in={question === 5}>
              <Content>
                The Cinema will strictly issue tickets for allocated seats as is
                in the system unless otherwise advised by the respective cinema.
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={6}>
              Can I change the cinema once I have booked the ticket?
            </Header1>
            <Collapse in={question === 6}>
              <Content>
                Once a ticket is booked from a particular cinema it cannot be
                changed and the money cannot be refunded.
              </Content>
              <Content>
                In the event you need to reach out to us don&#39;t hesitate to
                get in touch with us via email at{" "}
                <a
                  href="mailto:partnerships@little.africa"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  partnerships@little.africa
                </a>{" "}
                or via the{" "}
                <a
                  href="/contact-us"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  &ldquo;contact us&rdquo;
                </a>{" "}
                window in the app.
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={7}>
              If I book a &ldquo;wrong show time&rdquo; by mistake, can it be
              changed?
            </Header1>
            <Collapse in={question === 7}>
              <Content>
                Once a movie ticket is booked, the booking details cannot be
                changed. &nbsp;This includes the show time.
              </Content>
              <Content>
                In the event you need to reach out to us don&#39;t hesitate to
                get in touch with us via email at{" "}
                <a
                  href="mailto:partnerships@little.africa"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  partnerships@little.africa
                </a>{" "}
                or via the{" "}
                <a
                  href="/contact-us"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  &ldquo;contact us&rdquo;
                </a>{" "}
                window in the app.
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={8}>Can I change the movie once booked?</Header1>
            <Collapse in={question === 8}>
              <Content>
                Once a ticket for a particular movie is issued it cannot be
                changed because different movies are from different
                distributors.
              </Content>
              <Content>
                In the event you need to reach out to us don&#39;t hesitate to
                get in touch with us via email at{" "}
                <a
                  href="mailto:partnerships@little.africa"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  partnerships@little.africa
                </a>{" "}
                or via the{" "}
                <a
                  href="/contact-us"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  &ldquo;contact us&rdquo;
                </a>{" "}
                window in the app.
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={9}>How many tickets can I purchase online?</Header1>
            <Collapse in={question === 9}>
              <Content>
                You can book as many tickets as possible, provided the seats are
                available for booking via Little App.
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={10}>
              How can I collect a physical copy of the ticket booked?
            </Header1>
            <Collapse in={question === 10}>
              <Content>
                Yes. You can request a physical ticket at the counter of the
                respective cinema.
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={11}>
              What means of payment does the online ticketing accept?
            </Header1>
            <Collapse in={question === 11}>
              <Content>
                We have three modes of payment available.
                <ul>
                  <li>Visa/Mastercard</li>
                  <li>Little Wallet</li>
                  <li>M-pesa</li>
                </ul>
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={12}>
              Will I get a confirmation message after the payment process?
            </Header1>
            <Collapse in={question === 12}>
              <Content>
                Once you pay, you will receive an email confirmation with your
                ticket receipt. &nbsp;(Kindly note that the email is only sent
                if the customer has included the email address in their profile
                (located at the top left side of the Little App landing page)
              </Content>
            </Collapse>
          </li>
          <Divider sx={{ mb: 3 }} />
          <li className="li">
            <Header1 index={13}>
              What are the steps taken when booking a movie ticket via Little
              App?
            </Header1>
            <Collapse in={question === 13}>
              <Content>
                <ol className="ol2">
                  <li className="li2">
                    Log in to the Little App and click on &ldquo;Movies&rdquo;
                    under Entertainment category
                  </li>
                  <li className="li2">
                    (Option 1): Under &ldquo;Running Movies&rdquo;, click on
                    preferred movie and proceed to select the cinema <br />
                    (Option 2): Select &ldquo;Theatres near you&rdquo; and
                    select preferred theatre and movie
                  </li>
                  <li className="li2">
                    Select date, screen, and time, then click on &ldquo;Buy
                    Ticket&rdquo; and proceed to select seat(s)
                  </li>
                  <li className="li2">
                    Choose payment method (Little Wallet/ Mpesa) and Confirm
                    ticket booking
                  </li>
                </ol>
              </Content>
            </Collapse>
          </li>
        </ol>
        <div style={{ marginLeft: "10%" }}>
          <Header1 clickable={false}>Key contacts to note</Header1>
          <Content>
            Little Movies Support:{" "}
            <a
              href="mailto:partnerships@little.africa"
              style={{
                color: theme.palette.primary.main,
                textDecoration: "none",
              }}
            >
              partnerships@little.africa
            </a>
          </Content>
          <Content>
            Driver Support:{" "}
            <a
              href="mailto:operations@little.africa"
              style={{
                color: theme.palette.primary.main,
                textDecoration: "none",
              }}
            >
              operations@little.africa
            </a>
          </Content>
          <Content>
            Customer Support:{" "}
            <a
              href="mailto:customer-support@little.africa"
              style={{
                color: theme.palette.primary.main,
                textDecoration: "none",
              }}
            >
              customer-support@little.africa
            </a>
          </Content>
          <Content>
            Corporate Support:{" "}
            <a
              href="mailto:corporate@little.africa"
              style={{
                color: theme.palette.primary.main,
                textDecoration: "none",
              }}
            >
              corporate@little.africa
            </a>
          </Content>
        </div>
      </Stack>
    </Container>
  );
};
export default FAQ;
